// src/services/axiosConfig.ts
import axios from "axios";
import { getAccessToken, refreshToken, logout } from "./authService";

//Configure base URL based on environment
const baseURL = process.env.NODE_ENV === "production" 
  ? "https://apihiresmart.pineuron.com/api" 
  : "https://apihiresmart.pineuron.com/api"   // "https://localhost:7227/api";// "https://smarthrapi-fqa4ckg7brgsfmdz.uaenorth-01.azurewebsites.net/api"
//const baseURL="https://webapis-d4dtemcjd9htaxcy.eastasia-01.azurewebsites.net/api" 
const api = axios.create({
  baseURL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Request interceptor for auth token
api.interceptors.request.use(
  (config) => {
    const token = getAccessToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor for token refresh
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      
      try {
        const newAccessToken = await refreshToken();
        if (newAccessToken) {
          originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;
          return api(originalRequest);
        }
      } catch (refreshError) {
        console.error("Token refresh failed:", refreshError);
        logout();
        window.location.href = "/login";
        return Promise.reject(refreshError);
      }
    }
    
    return Promise.reject(error);
  }
);

export default api;